import httpStatusCodes from '../../httpStatusCodes.json';

export default httpStatusCodes;

export const CONTINUE = httpStatusCodes.CONTINUE;
export const SWITCHING_PROTOCOLS = httpStatusCodes.SWITCHING_PROTOCOLS;
export const PROCESSING = httpStatusCodes.PROCESSING;
export const EARLY_HINTS = httpStatusCodes.EARLY_HINTS;
export const OK = httpStatusCodes.OK;
export const CREATED = httpStatusCodes.CREATED;
export const ACCEPTED = httpStatusCodes.ACCEPTED;
export const NON_AUTHORITATIVE_INFORMATION = httpStatusCodes.NON_AUTHORITATIVE_INFORMATION;
export const NO_CONTENT = httpStatusCodes.NO_CONTENT;
export const RESET_CONTENT = httpStatusCodes.RESET_CONTENT;
export const PARTIAL_CONTENT = httpStatusCodes.PARTIAL_CONTENT;
export const MULTI_STATUS = httpStatusCodes.MULTI_STATUS;
export const ALREADY_REPORTED = httpStatusCodes.ALREADY_REPORTED;
export const IM_USED = httpStatusCodes.IM_USED;
export const MULTIPLE_CHOICES = httpStatusCodes.MULTIPLE_CHOICES;
export const MOVED_PERMANENTLY = httpStatusCodes.MOVED_PERMANENTLY;
export const FOUND = httpStatusCodes.FOUND;
export const SEE_OTHER = httpStatusCodes.SEE_OTHER;
export const NOT_MODIFIED = httpStatusCodes.NOT_MODIFIED;
export const USE_PROXY = httpStatusCodes.USE_PROXY;
export const UNUSED = httpStatusCodes.UNUSED;
export const TEMPORARY_REDIRECT = httpStatusCodes.TEMPORARY_REDIRECT;
export const PERMANENT_REDIRECT = httpStatusCodes.PERMANENT_REDIRECT;
export const BAD_REQUEST = httpStatusCodes.BAD_REQUEST;
export const UNAUTHORIZED = httpStatusCodes.UNAUTHORIZED;
export const PAYMENT_REQUIRED = httpStatusCodes.PAYMENT_REQUIRED;
export const FORBIDDEN = httpStatusCodes.FORBIDDEN;
export const NOT_FOUND = httpStatusCodes.NOT_FOUND;
export const METHOD_NOT_ALLOWED = httpStatusCodes.METHOD_NOT_ALLOWED;
export const NOT_ACCEPTABLE = httpStatusCodes.NOT_ACCEPTABLE;
export const PROXY_AUTHENTICATION_REQUIRED = httpStatusCodes.PROXY_AUTHENTICATION_REQUIRED;
export const REQUEST_TIMEOUT = httpStatusCodes.REQUEST_TIMEOUT;
export const CONFLICT = httpStatusCodes.CONFLICT;
export const GONE = httpStatusCodes.GONE;
export const LENGTH_REQUIRED = httpStatusCodes.LENGTH_REQUIRED;
export const PRECONDITION_FAILED = httpStatusCodes.PRECONDITION_FAILED;
export const PAYLOAD_TOO_LARGE = httpStatusCodes.PAYLOAD_TOO_LARGE;
export const URI_TOO_LONG = httpStatusCodes.URI_TOO_LONG;
export const UNSUPPORTED_MEDIA_TYPE = httpStatusCodes.UNSUPPORTED_MEDIA_TYPE;
export const RANGE_NOT_SATISFIABLE = httpStatusCodes.RANGE_NOT_SATISFIABLE;
export const EXPECTATION_FAILED = httpStatusCodes.EXPECTATION_FAILED;
export const IM_A_TEAPOT = httpStatusCodes.IM_A_TEAPOT;
export const MISDIRECTED_REQUEST = httpStatusCodes.MISDIRECTED_REQUEST;
export const UNPROCESSABLE_ENTITY = httpStatusCodes.UNPROCESSABLE_ENTITY;
export const LOCKED = httpStatusCodes.LOCKED;
export const FAILED_DEPENDENCY = httpStatusCodes.FAILED_DEPENDENCY;
export const TOO_EARLY = httpStatusCodes.TOO_EARLY;
export const UPGRADE_REQUIRED = httpStatusCodes.UPGRADE_REQUIRED;
export const PRECONDITION_REQUIRED = httpStatusCodes.PRECONDITION_REQUIRED;
export const TOO_MANY_REQUESTS = httpStatusCodes.TOO_MANY_REQUESTS;
export const REQUEST_HEADER_FIELDS_TOO_LARGE = httpStatusCodes.REQUEST_HEADER_FIELDS_TOO_LARGE;
export const UNAVAILABLE_FOR_LEGAL_REASONS = httpStatusCodes.UNAVAILABLE_FOR_LEGAL_REASONS;
export const INTERNAL_SERVER_ERROR = httpStatusCodes.INTERNAL_SERVER_ERROR;
export const NOT_IMPLEMENTED = httpStatusCodes.NOT_IMPLEMENTED;
export const BAD_GATEWAY = httpStatusCodes.BAD_GATEWAY;
export const SERVICE_UNAVAILABLE = httpStatusCodes.SERVICE_UNAVAILABLE;
export const GATEWAY_TIMEOUT = httpStatusCodes.GATEWAY_TIMEOUT;
export const HTTP_VERSION_NOT_SUPPORTED = httpStatusCodes.HTTP_VERSION_NOT_SUPPORTED;
export const VARIANT_ALSO_NEGOTIATES = httpStatusCodes.VARIANT_ALSO_NEGOTIATES;
export const INSUFFICIENT_STORAGE = httpStatusCodes.INSUFFICIENT_STORAGE;
export const LOOP_DETECTED = httpStatusCodes.LOOP_DETECTED;
export const NOT_EXTENDED = httpStatusCodes.NOT_EXTENDED;
export const NETWORK_AUTHENTICATION_REQUIRED = httpStatusCodes.NETWORK_AUTHENTICATION_REQUIRED;


export function isAuthorizationStatus(status: number) {
    return [httpStatusCodes.UNAUTHORIZED, httpStatusCodes.FORBIDDEN].includes(status);
}

export function isAuthorizationError(err: { status?: number; response?: { status: number; }; }) {
    return isAuthorizationStatus(err?.status ?? err?.response?.status);
}